import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Grid, Box, Typography, MenuItem, Link, Popover, ClickAwayListener } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../../../../store';
import useStyles from './styles';
import { loginActionNames } from '../../../../store/login/types';

const User = () => {
  const { displayName } = useSelector((state: AppState) => state.userPreference.customUserPreferences,);
  const { userRoleName } = useSelector((state: AppState) => state.userRole);
  const theme = useTheme();
  const classes = useStyles(theme);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [anchorElement, setAnchorElement] = useState(null);

  const handleToggle = (event: any) => {
    setAnchorElement(event.currentTarget);
    setOpen(!open);
  };

  const handleLogout = async () => {
    dispatch({
      type: loginActionNames.SET_LOGOUT,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Grid
        container
        paddingTop={1}
        direction="row"
        spacing={1}
        onClick={handleToggle}
        className={classes.userMenu}
        id="navbarUserSetting"
      >
        <Box>
          <Typography variant="body1" className={classes.title}>
            {displayName}
          </Typography>
          <Typography variant="body2" className={classes.title}>
            <ManageAccountsIcon color="action" fontSize="small" style={{ marginRight: 2 }} />{userRoleName}
          </Typography>
        </Box>
        <ExpandMore color="primary" className={classes.expand} fontSize="small" />
        <Popover
          open={open}
          anchorEl={anchorElement}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem key="Settings" onClick={handleClose}>
            <RouterLink to="/app-settings" className={classes.link}>
              Settings
            </RouterLink>
          </MenuItem>
          <MenuItem key="Logout" onClick={handleClose}>
            <Link
              href="https://login.cat.com/CwsLogin/cws/logout.htm"
              underline="none"
              className={classes.link}
              onClick={handleLogout}
            >
              Logout
            </Link>
          </MenuItem>
        </Popover>
      </Grid>
    </ClickAwayListener>
  );
};

export { User };
